import { persist } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import { createWithEqualityFn as create } from 'zustand/traditional'
import { shallow } from 'zustand/vanilla/shallow'

import { createSelectors } from '@/shared/lib/createSelectors.ts'

import {
	TutorialStore,
	tutorialStorePrototype
} from './tutorialStorePrototype.ts'

export const useTutorialStoreBase = create<TutorialStore>()(
	persist(immer(tutorialStorePrototype), {
		name: 'tutorial-v0'
	}),
	shallow
)

export const useTutorialStore = createSelectors(useTutorialStoreBase)
